module.exports = __webpack_public_path__ + "img/discount_howto3.fa0c7585.jpg";